import * as yup from 'yup';
import {
  alphabetRegix,
  alphaNumericRegix,
  numericDashRegix,
} from '../utils/functions';

export const international_tax_self_certification_schema = {
  isAgreeFatcaAndCrs: false,
  fullLegalNameOfTheEntity: '',
  country: '',
  city: '',
  currentResidenceCountry: '',
  currentResidenceCity: '',
  currentResidenceDistrict: '',
  currentResidenceBuildingNumber: '',
  currentResidenceStreetName: '',
  currentResidencePostalCode: '',
  mailingcountry: '',
  mailingcity: '',
  mailingdistrict: '',
  mailingbuildingNumber: '',
  mailingstreetName: '',
  mailingpostalCode: '',
  taxresidenceCountryJurisdiction: '',
  taxresidencetaxIdentificationNumber: '',
  taxResidenceNoTinReasonId: [],
  fatcaClassificationTinId: '',
  fatcaClassificationIsSpecifiedUsPerson: '',
  usPersonWhoIsNotASpecifiedUsPerson: '',
  crsClassificationId: '',
  depositoryInstitution: '',
  custodialInstitution: '',
  specifiedInsuranceCompany: '',
  anInvestmentEntityGrossIncomePrimarily: '',
  financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry: '',
  firstNameOfControllingPersons: '',
  middleNameOfControllingPersons: '',
  lastNameOfControllingPersons: '',
  crsClassificationAddressOfControllingPerson: '',
  cityOfControllingPersons: '',
  countryOfControllingPersons: '',
  districtOfControllingPersons: '',
  buildingNumberOfControllingPersons: '',
  streetNameOfControllingPersons: '',
  mailingAddressOfControllingPersons: '',
  crsClassificationNationalityOfControllingPerson: '',
  crsClassificationDateOfBirth: '',
  crsClassificationPlaceOfBirth: '',
  countryOfTaxResidenceOfControllingPersons: '',
  crsClassificationPercentageOfOwnerShip: '',
  controllingPersonStatusId: [],
  isConfirmTheAboveInformation: false,
};

export const international_tax_self_certification_validation_schema = yup
  .object()
  .shape({
    isAgreeFatcaAndCrs: yup.boolean().oneOf([true], 'agree_to_terms'),
    fullLegalNameOfTheEntity: yup.string().required('legal_name_required'),
    // country: yup
    //   .string()
    //   .required('country_required')
    //   .matches(alphabetRegix, 'must_be_alphabetic'),
    // Updated to string type to match country dropdown selection
    country: yup
      .object()
      .required('country_required'),
    city: yup.string().required('city_required'),
    // currentResidenceCountry: yup
    //   .string()
    //   .required('residence_country_required')
    //   .matches(alphabetRegix, 'must_be_alphabetic'),
    // Updated to string type to match country dropdown selection
    currentResidenceCountry: yup
      .object()
      .required('residence_country_required'),
    currentResidenceCity: yup.string().required('residence_city_required'),
    currentResidenceDistrict: yup
      .string()
      .required('residence_district_required')
      .matches(alphaNumericRegix, 'must_be_alphanumeric'),
    currentResidenceBuildingNumber: yup
      .string()
      .required('residence_building_number_required')
      .matches(numericDashRegix, 'invalid_building_no'),
    currentResidenceStreetName: yup
      .string()
      .required('residence_street_name_required')
      .matches(alphaNumericRegix, 'must_be_alphanumeric'),
    currentResidencePostalCode: yup
      .string()
      .required('residence_postal_code_required')
      .matches(numericDashRegix, 'invalid_postal_code'),
    // mailingcountry: yup
    //   .string()
    //   .required('mailing_country_required')
    //   .matches(alphabetRegix, 'must_be_alphabetic'),
    // Updated to object type to match country dropdown selection
    mailingcountry: yup
      .object()
      .required('mailing_country_required'),
    mailingcity: yup.string().required('mailing_city_required'),
    mailingdistrict: yup
      .string()
      .required('mailing_district_required')
      .matches(alphaNumericRegix, 'must_be_alphanumeric'),
    mailingbuildingNumber: yup
      .string()
      .required('mailing_building_number_required')
      .matches(numericDashRegix, 'invalid_building_no'),
    mailingstreetName: yup
      .string()
      .required('mailing_street_name_required')
      .matches(alphaNumericRegix, 'must_be_alphanumeric'),
    mailingpostalCode: yup
      .string()
      .required('mailing_postal_code_required')
      .matches(numericDashRegix, 'invalid_postal_code'),
    taxresidenceCountryJurisdiction: yup
      .string()
      .required('country_jurisdiction_required'),
    taxresidencetaxIdentificationNumber: yup
      .string()
      .matches(numericDashRegix, 'invalid_tin_equivalent_no')
      .test(
        'tin-or-reason',
        'tin_jurisdiction_required',
        function (value) {
          const { taxResidenceNoTinReasonId } = this.parent;

          const isTinEmpty = !value || value.trim() === '';
          const isReasonEmpty =
            !taxResidenceNoTinReasonId ||
            !Array.isArray(taxResidenceNoTinReasonId) ||
            taxResidenceNoTinReasonId.length === 0;

          // Agar dono empty hain to error
          if (isTinEmpty && isReasonEmpty) {
            return false;
          }

          return true;
        }
      ),
    taxResidenceNoTinReasonId: yup
      .array()
      .test(
        'reason-or-tin',
        'select_atleast_one',
        function (value) {
          const { taxresidencetaxIdentificationNumber } = this.parent;

          const isReasonEmpty =
            !value || !Array.isArray(value) || value.length === 0;

          const isTinEmpty =
            !taxresidencetaxIdentificationNumber ||
            taxresidencetaxIdentificationNumber.trim() === '';

          // Agar dono empty hain to error
          if (isReasonEmpty && isTinEmpty) {
            return false;
          }

          return true;
        }
      ),
    taxResidenceInfoReasonForNoTin: yup
      .string()
      .when('taxResidenceNoTinReasonId', {
        is: (val) => Array.isArray(val) && val[0]?.valueId === 1456,
        then: (schema) =>
          schema.required('tax_residence_no_tin_reason_required'),
        otherwise: (schema) => schema.notRequired(),
      }),

    fatcaClassificationTinId: yup
      .string()
      .required('select_atleast_one')
      .min(1, 'select_atleast_one'),

    // Conditionally required if fatcaClassificationTinId === 1458
    fatcaClassificationIsSpecifiedUsPerson: yup
      .boolean()
      .when('fatcaClassificationTinId', {
        is: (val) => Number(val) === 1458,
        then: (schema) => schema.required('specified_us_person_required'),
        otherwise: (schema) => schema.notRequired(),
      }),

    usPersonWhoIsNotASpecifiedUsPerson: yup
      .string()
      .when('fatcaClassificationTinId', {
        is: (val) => Number(val) === 1458,
        then: (schema) => schema.required('specified_us_person_required'),
        otherwise: (schema) => schema.notRequired(),
      }),

    fatcaClassificationUsTinNumber: yup
      .string()
      .when(
        ['fatcaClassificationTinId', 'fatcaClassificationIsSpecifiedUsPerson'],
        {
          is: (
            fatcaClassificationTinId,
            fatcaClassificationIsSpecifiedUsPerson
          ) =>
            Number(fatcaClassificationTinId) === 1458 &&
            Number(fatcaClassificationIsSpecifiedUsPerson) === 1,
          then: (schema) => schema.required('us_tin_required'),
          otherwise: (schema) => schema.notRequired(),
        }
      ),

    // If FATCA = Non-US Financial Institution (1459), then validate related fields
    ksaFinancialInstitution: yup.number().when('fatcaClassificationTinId', {
      is: 1459,
      then: (schema) =>
        schema.required('KSA Financial Institution selection is required'),
      otherwise: (schema) => schema.notRequired(),
    }),

    giinKsaFinancialInstitution: yup
      .string()
      .when(['fatcaClassificationTinId', 'ksaFinancialInstitution'], {
        is: (fatcaClassificationTinId, ksaFinancialInstitution) =>
          Number(fatcaClassificationTinId) === 1459 &&
          Number(ksaFinancialInstitution) === 1,
        then: (schema) =>
          schema
            .test('giin-or-reason', 'this_field_is_required', function (value) {
              const { reasonProvidedForNotHavingGiin } = this.parent;
              if (!value || value.trim() === '') {
                // GIIN empty → require Reason
                return (
                  !!reasonProvidedForNotHavingGiin &&
                  reasonProvidedForNotHavingGiin.trim() !== ''
                );
              }
              return true; // GIIN present → valid
            })
            .length(19, 'giin_must_be_16_digits'),
        otherwise: (schema) => schema.notRequired(),
      }),

    reasonProvidedForNotHavingGiin: yup
      .string()
      .when(['fatcaClassificationTinId', 'ksaFinancialInstitution'], {
        is: (fatcaClassificationTinId, ksaFinancialInstitution) =>
          Number(fatcaClassificationTinId) === 1459 &&
          Number(ksaFinancialInstitution) === 1,
        then: (schema) =>
          schema.test(
            'reason-or-giin',
            'this_field_is_required',
            function (value) {
              const { giinKsaFinancialInstitution } = this.parent;
              if (!value || value.trim() === '') {
                // Reason empty → require GIIN
                return (
                  !!giinKsaFinancialInstitution &&
                  giinKsaFinancialInstitution.trim() !== ''
                );
              }
              return true; // Reason present → valid
            }
          ),
        otherwise: (schema) => schema.notRequired(),
      }),

    giinParticipatingFinancialInstitution: yup
      .string()
      .when(['fatcaClassificationTinId', 'participatingFinancialInstitution'], {
        is: (val, participatingFinancialInstitution) => Number(val) === 1459 && Number(participatingFinancialInstitution) === 1,
        then: (schema) =>
          schema
            .required('this_field_is_required')
            .length(19, 'giin_must_be_16_digits'),
        otherwise: (schema) => schema.notRequired(),
      }),

    giinSponsoredControlledForeignCorporation: yup
      .string()
      .when(
        ['fatcaClassificationTinId', 'sponsoredControlledForeignCorporation'],
        {
          is: (
            fatcaClassificationTinId,
            sponsoredControlledForeignCorporation
          ) =>
            Number(fatcaClassificationTinId) === 1459 &&
            Number(sponsoredControlledForeignCorporation) === 1,
          then: (schema) =>
            schema
              .required('this_field_is_required')
              .length(19, 'giin_must_be_16_digits'),
          otherwise: (schema) => schema.notRequired(),
        }
      ),

    trusteesTrusteeDocumentedTrust: yup
      .string()
      .when(['fatcaClassificationTinId', 'trusteeDocumentedTrust'], {
        is: (fatcaClassificationTinId, trusteeDocumentedTrust) =>
          Number(fatcaClassificationTinId) === 1459 &&
          Number(trusteeDocumentedTrust) === 1,
        then: (schema) => schema.required('this_field_is_required'),
        otherwise: (schema) => schema.notRequired(),
      }),

    trusteesGiinTrusteeDocumentedTrust: yup
      .string()
      .when(['fatcaClassificationTinId', 'trusteeDocumentedTrust'], {
        is: (fatcaClassificationTinId, trusteeDocumentedTrust) =>
          Number(fatcaClassificationTinId) === 1459 &&
          Number(trusteeDocumentedTrust) === 1,
        then: (schema) =>
          schema
            .required('this_field_is_required')
            .length(19, 'giin_must_be_16_digits'),
        otherwise: (schema) => schema.notRequired(),
      }),

    specifyTypeProvidedInDomesticLaw: yup
      .string()
      .when(['crsClassificationId', 'isOtherEntityLowRiskUnderDomesticLaw'], {
        is: (crsClassificationId, isOtherEntityLowRiskUnderDomesticLaw) =>
          Number(crsClassificationId) === 1539 &&
          Number(isOtherEntityLowRiskUnderDomesticLaw) === 1,
        then: (schema) => schema.required('this_field_is_required'),
        otherwise: (schema) => schema.notRequired(),
      }),

    activeNFEOtherReason: yup
      .string()
      .when(['crsClassificationId', 'otherProvideReasonForThisSelection'], {
        is: (
          crsClassificationId,
          otherProvideReasonForThisSelection
        ) =>
          Number(crsClassificationId) === 1464 &&
          Number(otherProvideReasonForThisSelection) === 1,
        then: (schema) => schema.required('this_field_is_required'),
        otherwise: (schema) => schema.notRequired(),
      }),

    dateOfOrganization: yup
      .string()
      .when(['crsClassificationId', 'startupNfeDateOfOrg'], {
        is: (
          crsClassificationId,
          startupNfeDateOfOrg
        ) =>
          Number(crsClassificationId) === 1464 &&
          Number(startupNfeDateOfOrg) === 1,
        then: (schema) => schema.required('this_field_is_required'),
        otherwise: (schema) => schema.notRequired(),
      }),

    nameOfSecurityMarkets: yup
      .string()
      .when(['crsClassificationId', 'isActiveNfeRegularlyTradedCorporation'], {
        is: (crsClassificationId, isActiveNfeRegularlyTradedCorporation) =>
          Number(crsClassificationId) === 1464 &&
          Number(isActiveNfeRegularlyTradedCorporation) === 1,
        then: (schema) => schema.required('this_field_is_required'),
        otherwise: (schema) => schema.notRequired(),
      }),

    nameOfActiveNfeRelatedEntityOfRegTradedCorp: yup
      .string()
      .when(['crsClassificationId', 'isActiveNfeRegularlyTradedCorporation'], {
        is: (crsClassificationId, isActiveNfeRegularlyTradedCorporation) =>
          Number(crsClassificationId) === 1464 &&
          Number(isActiveNfeRegularlyTradedCorporation) === 1,
        then: (schema) => schema.required('this_field_is_required'),
        otherwise: (schema) => schema.notRequired(),
      }),

    dateOfIncorporation: yup
      .string()
      .when(['crsClassificationId', 'activeNfeOtherThan15Through17Above'], {
        is: (crsClassificationId, activeNfeOtherThan15Through17Above) =>
          Number(crsClassificationId) === 1464 &&
          Number(activeNfeOtherThan15Through17Above) === 1,
        then: (schema) => schema.required('this_field_is_required'),
        otherwise: (schema) => schema.notRequired(),
      }),

    // ======== 1461: NFFE Classification ========
    ExceptedNonFinancialUsEntity: yup
      .number()
      .when('fatcaClassificationTinId', {
        is: 1461,
        then: (schema) => schema.required('this_field_is_required'),
        otherwise: (schema) => schema.notRequired(),
      }),

    activeNonFinancialNonUsEntity: yup
      .number()
      .when('fatcaClassificationTinId', {
        is: 1461,
        then: (schema) => schema.required('this_field_is_required'),
        otherwise: (schema) => schema.notRequired(),
      }),

    directOrSponsoredReportingNonFinancialForeignEntity: yup
      .number()
      .when('fatcaClassificationTinId', {
        is: 1461,
        then: (schema) => schema.required('this_field_is_required'),
        otherwise: (schema) => schema.notRequired(),
      }),

    giinDirectOrSponsoredReportingNonFinancialForeignEntity: yup
      .string()
      .when(['fatcaClassificationTinId', 'directOrSponsoredReportingNonFinancialForeignEntity'], {
        is: (fatcaClassificationTinId, directOrSponsoredReportingNonFinancialForeignEntity) =>
          Number(fatcaClassificationTinId) === 1461 && Number(directOrSponsoredReportingNonFinancialForeignEntity) === 1,
        then: (schema) =>
          schema
            .required('this_field_is_required')
            .length(19, 'giin_must_be_16_digits'),
        otherwise: (schema) => schema.notRequired(),
      }),

    crsClassificationId: yup.string().required('crs_classification_required'),
    depositoryInstitution: yup
      .boolean()
      .when('crsClassificationId', (val, schema) => {
        if (Number(val) === 1463) {
          return schema.required('depository_institution_required');
        }
        return schema.notRequired();
      }),
    custodialInstitution: yup
      .boolean()
      .when('crsClassificationId', (val, schema) => {
        if (Number(val) === 1463) {
          return schema.required('custodial_insitution_required');
        }
        return schema.notRequired();
      }),
    specifiedInsuranceCompany: yup
      .boolean()
      .when('crsClassificationId', (val, schema) => {
        if (Number(val) === 1463) {
          return schema.required('specified_insurance_company_required');
        }
        return schema.notRequired();
      }),
    anInvestmentEntityGrossIncomePrimarily: yup
      .boolean()
      .when('crsClassificationId', (val, schema) => {
        if (Number(val) === 1463) {
          return schema.required('insurance_company_required');
        }
        return schema.notRequired();
      }),
    investmentEntityTypes: yup
      .array()
      .of(yup.object().shape({ valueId: yup.string().required() }))
      .when(['crsClassificationId', 'anInvestmentEntityGrossIncomePrimarily'], {
        is: (crsClassificationId, anInvestmentEntityGrossIncomePrimarily) =>
          Number(crsClassificationId) === 1463 && Number(anInvestmentEntityGrossIncomePrimarily) === 1,
        then: (schema) =>
          schema
            .min(1, 'this_field_is_required')
            .required('this_field_is_required'),
        otherwise: (schema) => schema.notRequired(),
      }),
    financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry: yup
      .number()
      .oneOf([0, 1])
      .required('This field is required'),

    // Controlling Person

    firstNameOfControllingPersons: yup
      .string()
      .when(
        [
          'crsClassificationId',
          'financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry',
          'passiveNfe',
          'fatcaClassificationTinId',
          'passiveNonFinancialNonUsEntity',
        ],
        {
          is: (
            crsClassificationId,
            financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry,
            passiveNfe,
            fatcaClassificationTinId,
            passiveNonFinancialNonUsEntity
          ) =>
            (Number(crsClassificationId) === 1463 &&
              Number(
                financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry
              ) === 1) ||
            (Number(crsClassificationId) === 1465 &&
              Number(passiveNfe) === 1) ||
            (Number(fatcaClassificationTinId) === 1462 &&
              Number(passiveNonFinancialNonUsEntity) === 1),
          then: (schema) =>
            schema.required('controlling_person_first_name_required')
              .matches(alphabetRegix, 'first_name_place_must_be_alphabetic'),
          otherwise: (schema) => schema.notRequired(),
        }
      ),
    middleNameOfControllingPersons: yup
      .string()
      .when(
        [
          'crsClassificationId',
          'financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry',
          'passiveNfe',
          'fatcaClassificationTinId',
          'passiveNonFinancialNonUsEntity',
        ],
        {
          is: (
            crsClassificationId,
            financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry,
            passiveNfe,
            fatcaClassificationTinId,
            passiveNonFinancialNonUsEntity
          ) =>
            (Number(crsClassificationId) === 1463 &&
              Number(
                financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry
              ) === 1) ||
            (Number(crsClassificationId) === 1465 &&
              Number(passiveNfe) === 1) ||
            (Number(fatcaClassificationTinId) === 1462 &&
              Number(passiveNonFinancialNonUsEntity) === 1),
          then: (schema) =>
            schema.required('controlling_person_middle_name_required')
              .matches(alphabetRegix, 'middle_name_place_must_be_alphabetic'),
          otherwise: (schema) => schema.notRequired(),
        }
      ),
    lastNameOfControllingPersons: yup
      .string()
      .when(
        [
          'crsClassificationId',
          'financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry',
          'passiveNfe',
          'fatcaClassificationTinId',
          'passiveNonFinancialNonUsEntity',
        ],
        {
          is: (
            crsClassificationId,
            financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry,
            passiveNfe,
            fatcaClassificationTinId,
            passiveNonFinancialNonUsEntity
          ) =>
            (Number(crsClassificationId) === 1463 &&
              Number(
                financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry
              ) === 1) ||
            (Number(crsClassificationId) === 1465 &&
              Number(passiveNfe) === 1) ||
            (Number(fatcaClassificationTinId) === 1462 &&
              Number(passiveNonFinancialNonUsEntity) === 1),
          then: (schema) =>
            schema.required('controlling_person_last_name_required')
              .matches(alphabetRegix, 'last_name_place_must_be_alphabetic'),
          otherwise: (schema) => schema.notRequired(),
        }
      ),
    crsClassificationAddressOfControllingPerson: yup
      .string()
      .when(
        [
          'crsClassificationId',
          'financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry',
          'passiveNfe',
          'fatcaClassificationTinId',
          'passiveNonFinancialNonUsEntity',
        ],
        {
          is: (
            crsClassificationId,
            financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry,
            passiveNfe,
            fatcaClassificationTinId,
            passiveNonFinancialNonUsEntity
          ) =>
            (Number(crsClassificationId) === 1463 &&
              Number(
                financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry
              ) === 1) ||
            (Number(crsClassificationId) === 1465 &&
              Number(passiveNfe) === 1) ||
            (Number(fatcaClassificationTinId) === 1462 &&
              Number(passiveNonFinancialNonUsEntity) === 1),
          then: (schema) =>
            schema
              .required('controlling_person_current_residence_required')
              .matches(alphaNumericRegix, 'must_be_alphanumeric'),
          otherwise: (schema) => schema.notRequired(),
        }
      ),
    cityOfControllingPersons: yup
      .string()
      .when(
        [
          'crsClassificationId',
          'financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry',
          'passiveNfe',
          'fatcaClassificationTinId',
          'passiveNonFinancialNonUsEntity',
        ],
        {
          is: (
            crsClassificationId,
            financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry,
            passiveNfe,
            fatcaClassificationTinId,
            passiveNonFinancialNonUsEntity
          ) =>
            (Number(crsClassificationId) === 1463 &&
              Number(
                financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry
              ) === 1) ||
            (Number(crsClassificationId) === 1465 &&
              Number(passiveNfe) === 1) ||
            (Number(fatcaClassificationTinId) === 1462 &&
              Number(passiveNonFinancialNonUsEntity) === 1),
          then: (schema) => schema.required('controlling_person_city_required')
            .matches(alphabetRegix, 'city_place_must_be_alphabetic'),
          otherwise: (schema) => schema.notRequired(),
        }
      ),
    countryOfControllingPersons: yup
      .object()
      .when(
        [
          'crsClassificationId',
          'financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry',
          'passiveNfe',
          'fatcaClassificationTinId',
          'passiveNonFinancialNonUsEntity',
        ],
        {
          is: (
            crsClassificationId,
            financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry,
            passiveNfe,
            fatcaClassificationTinId,
            passiveNonFinancialNonUsEntity
          ) =>
            (Number(crsClassificationId) === 1463 &&
              Number(
                financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry
              ) === 1) ||
            (Number(crsClassificationId) === 1465 &&
              Number(passiveNfe) === 1) ||
            (Number(fatcaClassificationTinId) === 1462 &&
              Number(passiveNonFinancialNonUsEntity) === 1),
          then: (schema) =>
            schema
              .required('controlling_person_country_required'),
          // .matches(alphabetRegix, 'must_be_alphabetic'),
          otherwise: (schema) => schema.notRequired(),
        }
      ),
    districtOfControllingPersons: yup
      .string()
      .when(
        [
          'crsClassificationId',
          'financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry',
          'passiveNfe',
          'fatcaClassificationTinId',
          'passiveNonFinancialNonUsEntity',
        ],
        {
          is: (
            crsClassificationId,
            financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry,
            passiveNfe,
            fatcaClassificationTinId,
            passiveNonFinancialNonUsEntity
          ) =>
            (Number(crsClassificationId) === 1463 &&
              Number(
                financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry
              ) === 1) ||
            (Number(crsClassificationId) === 1465 &&
              Number(passiveNfe) === 1) ||
            (Number(fatcaClassificationTinId) === 1462 &&
              Number(passiveNonFinancialNonUsEntity) === 1),
          then: (schema) =>
            schema
              .required('controlling_person_district_required')
              .matches(alphabetRegix, 'district_place_must_be_alphabetic'),
          otherwise: (schema) => schema.notRequired(),
        }
      ),
    buildingNumberOfControllingPersons: yup
      .string()
      .when(
        [
          'crsClassificationId',
          'financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry',
          'passiveNfe',
          'fatcaClassificationTinId',
          'passiveNonFinancialNonUsEntity',
        ],
        {
          is: (
            crsClassificationId,
            financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry,
            passiveNfe,
            fatcaClassificationTinId,
            passiveNonFinancialNonUsEntity
          ) =>
            (Number(crsClassificationId) === 1463 &&
              Number(
                financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry
              ) === 1) ||
            (Number(crsClassificationId) === 1465 &&
              Number(passiveNfe) === 1) ||
            (Number(fatcaClassificationTinId) === 1462 &&
              Number(passiveNonFinancialNonUsEntity) === 1),
          then: (schema) =>
            schema
              .required('controlling_person_building_number_required')
              .matches(numericDashRegix, 'invalid_building_no'),
          otherwise: (schema) => schema.notRequired(),
        }
      ),
    streetNameOfControllingPersons: yup
      .string()
      .when(
        [
          'crsClassificationId',
          'financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry',
          'passiveNfe',
          'fatcaClassificationTinId',
          'passiveNonFinancialNonUsEntity',
        ],
        {
          is: (
            crsClassificationId,
            financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry,
            passiveNfe,
            fatcaClassificationTinId,
            passiveNonFinancialNonUsEntity
          ) =>
            (Number(crsClassificationId) === 1463 &&
              Number(
                financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry
              ) === 1) ||
            (Number(crsClassificationId) === 1465 &&
              Number(passiveNfe) === 1) ||
            (Number(fatcaClassificationTinId) === 1462 &&
              Number(passiveNonFinancialNonUsEntity) === 1),
          then: (schema) =>
            schema
              .required('controlling_person_street_name_required')
              .matches(numericDashRegix, 'invalid_street_no'),
          otherwise: (schema) => schema.notRequired(),
        }
      ),
    mailingAddressOfControllingPersons: yup
      .string()
      .when(
        [
          'crsClassificationId',
          'financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry',
          'passiveNfe',
          'fatcaClassificationTinId',
          'passiveNonFinancialNonUsEntity',
        ],
        {
          is: (
            crsClassificationId,
            financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry,
            passiveNfe,
            fatcaClassificationTinId,
            passiveNonFinancialNonUsEntity
          ) =>
            (Number(crsClassificationId) === 1463 &&
              Number(
                financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry
              ) === 1) ||
            (Number(crsClassificationId) === 1465 &&
              Number(passiveNfe) === 1) ||
            (Number(fatcaClassificationTinId) === 1462 &&
              Number(passiveNonFinancialNonUsEntity) === 1),
          then: (schema) =>
            schema
              .required('controlling_person_mailing_address_required')
              .matches(alphaNumericRegix, 'must_be_alphanumeric'),
          otherwise: (schema) => schema.notRequired(),
        }
      ),
    crsClassificationNationalityOfControllingPerson: yup
      .string()
      .when(
        [
          'crsClassificationId',
          'financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry',
          'passiveNfe',
          'fatcaClassificationTinId',
          'passiveNonFinancialNonUsEntity',
        ],
        {
          is: (
            crsClassificationId,
            financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry,
            passiveNfe,
            fatcaClassificationTinId,
            passiveNonFinancialNonUsEntity
          ) =>
            (Number(crsClassificationId) === 1463 &&
              Number(
                financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry
              ) === 1) ||
            (Number(crsClassificationId) === 1465 &&
              Number(passiveNfe) === 1) ||
            (Number(fatcaClassificationTinId) === 1462 &&
              Number(passiveNonFinancialNonUsEntity) === 1),
          then: (schema) =>
            schema.required('controlling_person_citizenship_required')
              .matches(alphabetRegix, 'citizenship_place_must_be_alphabetic'),
          otherwise: (schema) => schema.notRequired(),
        }
      ),
    crsClassificationDateOfBirth: yup
      .string()
      .when(
        [
          'crsClassificationId',
          'financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry',
          'passiveNfe',
          'fatcaClassificationTinId',
          'passiveNonFinancialNonUsEntity',
        ],
        {
          is: (
            crsClassificationId,
            financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry,
            passiveNfe,
            fatcaClassificationTinId,
            passiveNonFinancialNonUsEntity
          ) =>
            (Number(crsClassificationId) === 1463 &&
              Number(
                financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry
              ) === 1) ||
            (Number(crsClassificationId) === 1465 &&
              Number(passiveNfe) === 1) ||
            (Number(fatcaClassificationTinId) === 1462 &&
              Number(passiveNonFinancialNonUsEntity) === 1),
          then: (schema) => schema.required('controlling_person_dob_required'),
          otherwise: (schema) => schema.notRequired(),
        }
      ),
    crsClassificationPlaceOfBirth: yup
      .string()
      .when(
        [
          'crsClassificationId',
          'financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry',
          'passiveNfe',
          'fatcaClassificationTinId',
          'passiveNonFinancialNonUsEntity',
        ],
        {
          is: (
            crsClassificationId,
            financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry,
            passiveNfe,
            fatcaClassificationTinId,
            passiveNonFinancialNonUsEntity
          ) =>
            (Number(crsClassificationId) === 1463 &&
              Number(
                financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry
              ) === 1) ||
            (Number(crsClassificationId) === 1465 &&
              Number(passiveNfe) === 1) ||
            (Number(fatcaClassificationTinId) === 1462 &&
              Number(passiveNonFinancialNonUsEntity) === 1),
          then: (schema) => schema.required('controlling_person_pob_required'),
          otherwise: (schema) => schema.notRequired(),
        }
      ),
    countryOfTaxResidenceOfControllingPersons: yup
      .string()
      .when(
        [
          'crsClassificationId',
          'financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry',
          'passiveNfe',
          'fatcaClassificationTinId',
          'passiveNonFinancialNonUsEntity',
        ],
        {
          is: (
            crsClassificationId,
            financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry,
            passiveNfe,
            fatcaClassificationTinId,
            passiveNonFinancialNonUsEntity
          ) =>
            (Number(crsClassificationId) === 1463 &&
              Number(
                financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry
              ) === 1) ||
            (Number(crsClassificationId) === 1465 &&
              Number(passiveNfe) === 1) ||
            (Number(fatcaClassificationTinId) === 1462 &&
              Number(passiveNonFinancialNonUsEntity) === 1),
          then: (schema) =>
            schema.required('controlling_person_tax_residency_required'),
          otherwise: (schema) => schema.notRequired(),
        }
      ),
    crsClassificationPercentageOfOwnerShip: yup
      .number()
      .when(
        [
          'crsClassificationId',
          'financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry',
          'passiveNfe',
          'fatcaClassificationTinId',
          'passiveNonFinancialNonUsEntity',
        ],
        {
          is: (
            crsClassificationId,
            financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry,
            passiveNfe,
            fatcaClassificationTinId,
            passiveNonFinancialNonUsEntity
          ) =>
            (Number(crsClassificationId) === 1463 &&
              Number(
                financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry
              ) === 1) ||
            (Number(crsClassificationId) === 1465 &&
              Number(passiveNfe) === 1) ||
            (Number(fatcaClassificationTinId) === 1462 &&
              Number(passiveNonFinancialNonUsEntity) === 1),
          then: (schema) =>
            schema
              .required('controlling_person_percentage_ownership_required')
              .typeError('percentage_must_be_numeric')
              .min(0, 'percentage_cannot_be_less_than_0')
              .max(100, 'percentage_cannot_exceed_100'),
          otherwise: (schema) => schema.notRequired(),
        }
      ),
    zipcodeOfControllingPersons: yup
      .string()
      .when(
        [
          'crsClassificationId',
          'financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry',
          'passiveNfe',
          'fatcaClassificationTinId',
          'passiveNonFinancialNonUsEntity',
        ],
        {
          is: (
            crsClassificationId,
            financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry,
            passiveNfe,
            fatcaClassificationTinId,
            passiveNonFinancialNonUsEntity
          ) =>
            (Number(crsClassificationId) === 1463 &&
              Number(
                financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry
              ) === 1) ||
            (Number(crsClassificationId) === 1465 &&
              Number(passiveNfe) === 1) ||
            (Number(fatcaClassificationTinId) === 1462 &&
              Number(passiveNonFinancialNonUsEntity) === 1),
          then: (schema) =>
            schema
              .required('zipcode_required')
              .matches(numericDashRegix, 'invalid_zip_code'),
          otherwise: (schema) => schema.notRequired(),
        }
      ),
    additionalNoOfControllingPersons: yup
      .string()
      .when(
        [
          'crsClassificationId',
          'financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry',
          'passiveNfe',
          'fatcaClassificationTinId',
          'passiveNonFinancialNonUsEntity',
        ],
        {
          is: (
            crsClassificationId,
            financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry,
            passiveNfe,
            fatcaClassificationTinId,
            passiveNonFinancialNonUsEntity
          ) =>
            (Number(crsClassificationId) === 1463 &&
              Number(
                financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry
              ) === 1) ||
            (Number(crsClassificationId) === 1465 &&
              Number(passiveNfe) === 1) ||
            (Number(fatcaClassificationTinId) === 1462 &&
              Number(passiveNonFinancialNonUsEntity) === 1),
          then: (schema) =>
            schema
              .required('additional_number_required')
              .matches(numericDashRegix, 'invalid_additional_no'),
          // .matches(phoneRegex, 'invalid_phone_no'),
          otherwise: (schema) => schema.notRequired(),
        }
      ),

    tinForControllingPerson: yup
      .string()
      .when(
        [
          'crsClassificationId',
          'financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry',
          'passiveNfe',
          'fatcaClassificationTinId',
          'passiveNonFinancialNonUsEntity',
        ],
        {
          is: (
            crsClassificationId,
            financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry,
            passiveNfe,
            fatcaClassificationTinId,
            passiveNonFinancialNonUsEntity
          ) =>
            (Number(crsClassificationId) === 1463 &&
              Number(
                financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry
              ) === 1) ||
            (Number(crsClassificationId) === 1465 &&
              Number(passiveNfe) === 1) ||
            (Number(fatcaClassificationTinId) === 1462 &&
              Number(passiveNonFinancialNonUsEntity) === 1),
          then: (schema) =>
            schema
              .matches(numericDashRegix, 'invalid_tin_or_its_no')
              .test(
                'tin-or-reason-person',
                'this_field_is_required',
                function (value) {
                  const { unavailbleTINControllingPersonReasonId } = this.parent;

                  const isTinEmpty = !value || value.trim() === '';
                  const isReasonEmpty =
                    !unavailbleTINControllingPersonReasonId ||
                    !Array.isArray(unavailbleTINControllingPersonReasonId) ||
                    unavailbleTINControllingPersonReasonId.length === 0;

                  if (isTinEmpty && isReasonEmpty) {
                    return false;
                  }

                  return true;
                }
              ),
          otherwise: (schema) => schema.notRequired(),
        }
      ),
    unavailbleTINControllingPersonReasonId: yup
      .array()
      .when(
        [
          'crsClassificationId',
          'financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry',
          'passiveNfe',
          'fatcaClassificationTinId',
          'passiveNonFinancialNonUsEntity',
        ],
        {
          is: (
            crsClassificationId,
            financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry,
            passiveNfe,
            fatcaClassificationTinId,
            passiveNonFinancialNonUsEntity
          ) =>
            (Number(crsClassificationId) === 1463 &&
              Number(financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry) === 1) ||
            (Number(crsClassificationId) === 1465 &&
              Number(passiveNfe) === 1) ||
            (Number(fatcaClassificationTinId) === 1462 &&
              Number(passiveNonFinancialNonUsEntity) === 1),
          then: (schema) =>
            schema
              .test(
                'reason-or-tin-person',
                'this_field_is_required',
                function (value) {
                  const { tinForControllingPerson } = this.parent;

                  const isReasonEmpty =
                    !value || !Array.isArray(value) || value.length === 0;

                  const isTinEmpty =
                    !tinForControllingPerson ||
                    tinForControllingPerson.trim() === '';

                  if (isReasonEmpty && isTinEmpty) {
                    return false;
                  }

                  return true;
                }
              ),
          otherwise: (schema) => schema.notRequired(),
        }
      ),

    reasonForTINUnavailableForControllingPerson: yup.string().when(
      'unavailbleTINControllingPersonReasonId',
      {
        is: (val) => Number(val?.[0]?.valueId) === 1456,
        then: schema => schema.required('this_field_is_required'),
        otherwise: schema => schema.notRequired(),
      },
    ),
    controllingPersonStatusId: yup
      .array()
      .when(
        [
          'crsClassificationId',
          'financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry',
          'passiveNfe',
          'fatcaClassificationTinId',
          'passiveNonFinancialNonUsEntity',
        ],
        {
          is: (
            crsClassificationId,
            financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry,
            passiveNfe,
            fatcaClassificationTinId,
            passiveNonFinancialNonUsEntity
          ) =>
            (Number(crsClassificationId) === 1463 &&
              Number(financialInstitutionInvestmentEntityLocatedInANonParticipatingCountry) === 1) ||
            (Number(crsClassificationId) === 1465 &&
              Number(passiveNfe) === 1) ||
            (Number(fatcaClassificationTinId) === 1462 &&
              Number(passiveNonFinancialNonUsEntity) === 1),
          then: (schema) =>
            schema
              .min(1, 'controlling_person_ticking_status_required')
              .required('controlling_person_ticking_status_required'),
          otherwise: (schema) => schema.notRequired(),
        }
      ),

    isConfirmTheAboveInformation: yup
      .boolean()
      .oneOf([true], 'must_agree_to_declaration'),
  });
export const ControllingPersonsNullData = {
  firstNameOfControllingPersons: null,
  crsClassificationAddressOfControllingPerson: null,
  middleNameOfControllingPersons: null,
  lastNameOfControllingPersons: null,
  cityOfControllingPersons: null,
  countryOfControllingPersons: null,
  districtOfControllingPersons: null,
  buildingNumberOfControllingPersons: null,
  streetNameOfControllingPersons: null,
  mailingAddressOfControllingPersons: null,
  crsClassificationNationalityOfControllingPerson: null,
  crsClassificationDateOfBirth: null,
  crsClassificationPlaceOfBirth: null,
  countryOfTaxResidenceOfControllingPersons: null,
  crsClassificationPercentageOfOwnerShip: null,
  controllingPersonStatusId: null,
};
